const selectors = {
  token: (state) => state.auth.token,
  refreshToken: (state) => state.auth.refreshToken,
};

export { selectors };
